import { retrieveData, storeData } from "./LocalConnection";
import {
  DB_NAME,
  array_data_base,
  CustomerOrderDetail,
  CustomerOrder,
  CustomerOrderPaymentMode,
  GuestInformation,
  SYNC_STORE,
  initDB,
  openIndexDB,
  ReservationInformation,
  add_update_to_sync_table,
} from "./OfflineConnection";

const deleteDatabase = () => {
  const request = indexedDB.deleteDatabase(DB_NAME);

  request.onsuccess = function () {
    console.log(`Database "${DB_NAME}" deleted successfully`);
  };

  request.onerror = function () {
    console.error(`Failed to delete database "${DB_NAME}"`);
  };

  request.onblocked = function () {
    console.warn(
      `Database "${DB_NAME}" deletion blocked. Close open connections.`
    );
  };
};

async function checkInternet_for_sync() {
  try {
    const response = await fetch("https://www.uprestro.com/favicon.ico", {
      mode: "no-cors",
    });
    return false; // Online
  } catch (error) {
    return true; // Offline
  }
}

const StoreDataintoIndexDB = async (
  transaction,
  storeName,
  data,
  extra_data
) => {
  const store = transaction.objectStore(storeName);

  if (extra_data.clear_or_not === "clear") {
    store.clear();
  }
  if (!Array.isArray(data) || data.length === 0) return; // Skip if data is empty
  if (extra_data.flag === "0") {
    if (data) {
      data.forEach((dataItem) => {
        const modifiedDataItem = {
          ...dataItem,
          id: dataItem.primary_id, // Ensure primary_id is stored as id
          data_type: "online",
        };
        store.add(modifiedDataItem);
      });
    }
  } else if (extra_data.flag === "1") {
    if (data) {
      data.forEach((dataItem) => {
        const modifiedDataItem = {
          ...dataItem,
          id: dataItem.primary_id, // Ensure primary_id is stored as id
          item_original_price: parseFloat(dataItem.item_amount).toFixed(2),
          total_price_show_single: parseFloat(dataItem.total_amount).toFixed(2),
          total_price_show: parseFloat(dataItem.item_amount).toFixed(2),
          data_type: "online",
        };

        store.add(modifiedDataItem);
      });
    }
  }
};

const RetrieveDataintoIndexDB = async (db, storeName, extra_data) => {
  try {
    if (db == null) {
      db = await openIndexDB();
    }
    const transaction = db.transaction(storeName, "readonly");
    const store = transaction.objectStore(storeName);

    let index, keyRange, request;

    // **Determine Index & KeyRange for Efficient Searching**
    if (extra_data.order_id && extra_data.order_id !== "0") {
      index = store.index("order_id");
      keyRange = IDBKeyRange.only(
        isNaN(extra_data.order_id)
          ? String(extra_data.order_id)
          : Number(extra_data.order_id)
      );
    } else if (extra_data.table_no) {
      index = store.index("table_no");
      keyRange = IDBKeyRange.only(extra_data.table_no);
    }

    // **Use getAll() for Faster Retrieval**
    request = index ? index.getAll(keyRange) : store.getAll();

    return new Promise((resolve, reject) => {
      request.onsuccess = (event) => {
        let filteredData = event.target.result;

        // **Apply details_wala Filter**
        if (extra_data.details_wala && extra_data.details_wala === "2") {
          filteredData = filteredData.filter(
            (item) => Number(item.current_status) !== 2
          );
        }

        resolve(filteredData);
      };

      request.onerror = (event) => {
        reject(
          new Error(
            `Error retrieving data from ${storeName}: ${event.target.error}`
          )
        );
      };
    });
  } catch (error) {
    console.error(`RetrieveDataintoIndexDB Error:`, error);
    return [];
  }
};

const RetrieveDataintoIndexDBOrder = async (db, storeName, extra_data) => {
  try {
    if (db == null) {
      db = await openIndexDB();
    }
    const transaction = db.transaction(storeName, "readonly");
    const store = transaction.objectStore(storeName);

    let index, keyRange, request;

    // **Determine Index & KeyRange for Efficient Searching**
    if (extra_data.order_id && extra_data.order_id !== "0") {
      index = store.index("order_id");
      keyRange = IDBKeyRange.only(
        isNaN(extra_data.order_id)
          ? String(extra_data.order_id)
          : Number(extra_data.order_id)
      );
    } else if (extra_data.table_no) {
      index = store.index("table_no");
      keyRange = IDBKeyRange.only(extra_data.table_no);
    }
    // **Use getAll() for Faster Retrieval**

    if (index) {
      request = index.getAll(keyRange);

      return new Promise((resolve, reject) => {
        request.onsuccess = (event) => {
          let filteredData = event.target.result;

          // **Apply details_wala Filter**
          if (extra_data.details_wala && extra_data.details_wala === "2") {
            filteredData = filteredData.filter(
              (item) => Number(item.current_status) !== 2
            );
          }

          resolve(filteredData);
        };

        request.onerror = (event) => {
          reject(
            new Error(
              `Error retrieving data from ${storeName}: ${event.target.error}`
            )
          );
        };
      });
    } else {
      return [];
    }
  } catch (error) {
    console.error(`RetrieveDataintoIndexDB Error:`, error);
    return [];
  }
};

const StoreDataItemintoIndexDB = async (
  transaction,
  storeName,
  data,
  order_type = "",
  extra_data = {}
) => {
  try {
    let order_id_final = 0;

    if (extra_data.order_id && extra_data.order_id !== "0") {
      order_id_final = extra_data.order_id;
    }
    const store = transaction.objectStore(storeName);
    return new Promise((resolve, reject) => {
      const { primary_id } = data;
      let item_id = primary_id;
      if (data.item_id) {
        item_id = data.item_id;
      }

      let foundRecord = null;
      let index, keyRange, request;

      if (extra_data.order_id && extra_data.order_id !== "0") {
        index = store.index("order_id");
        if (/^\d+$/.test(extra_data.order_id)) {
          keyRange = IDBKeyRange.only(parseInt(extra_data.order_id)); // Ensure number type
          order_id_final = parseInt(extra_data.order_id);
        } else {
          keyRange = IDBKeyRange.only(String(extra_data.order_id));
        }
      } else if (extra_data.table_no) {
        index = store.index("table_no");
        keyRange = IDBKeyRange.only(extra_data.table_no);
      }

      // **Use getAll() when possible for faster bulk retrieval**
      if (index) {
        request = index.getAll(keyRange); // Faster than opening a cursor if fetching all matching records
      } else {
        request = store.getAll(); // Only use when no indexed search is possible
      }
      request.onsuccess = async (event) => {
        const records = event.target.result;
        let orderExists = false;
        if (extra_data.type === "take") {
          orderExists = records.some(
            (item) =>
              item.order_id === extra_data.order_id &&
              parseInt(item.current_status) !== 2 &&
              parseInt(item.current_status) !== 10
          );
        } else if (extra_data.type === "delivery") {
          orderExists = records.some(
            (item) =>
              item.order_id === extra_data.order_id &&
              parseInt(item.current_status) !== 2 &&
              parseInt(item.current_status) !== 10
          );
        } else {
          orderExists = records.some(
            (item) =>
              (item.order_id === extra_data.order_id ||
                item.table_no === extra_data.table_no) &&
              parseInt(item.current_status) !== 2 &&
              parseInt(item.current_status) !== 10
          );
        }

        let variation_name = "";
        if (
          extra_data &&
          extra_data.selectedVariation &&
          extra_data.selectedVariation.variation_name
        ) {
          variation_name = extra_data.selectedVariation.variation_name;
        }

        records.forEach((cake) => {
          let match_variation = "";
          if (cake.selectedVariation) {
            match_variation = cake.selectedVariation.variation_name;
          }
          let isAddonsEqual = true;

          if (cake.selectedAddons) {
            isAddonsEqual = areAddonsEqual(
              cake.selectedAddons,
              extra_data.selectedAddons
            );
          }
          if (
            cake.item_id === item_id &&
            match_variation === variation_name &&
            cake.order_id === extra_data.order_id &&
            isAddonsEqual &&
            !foundRecord
          ) {
            foundRecord = cake;
          }
        });
        let item_original_price = data.item_original_price;

        if (foundRecord !== null) {
          item_original_price = foundRecord.item_original_price;
        }
        if (extra_data && extra_data.total_amount > 0) {
          item_original_price = extra_data.total_amount;
        }
        let order_not_created = false;

        if (extra_data.order_id && extra_data.order_id !== "0") {
          order_not_created = true;
        }

        if (!orderExists && !order_not_created) {
          const store2 = transaction.objectStore(CustomerOrder);

          order_id_final = 0;

          if (order_type === "dine") {
            order_type = "3";
          } else if (order_type === "delivery") {
            order_type = "2";
          } else if (order_type === "take") {
            order_type = "1";
          } else {
            order_type = "0";
          }
          const retrievedAdminId = retrieveData("admin_id");
          const retrievedRestaurantId = retrieveData("default_restaurant_id");
          //0 means order food qr code ,1 means takeaway,2 means delivery 3 means Table Reservation
          const modifiedDataItem = {
            order_id: order_id_final, // Ensure this maps to primary_id in Django
            primary_id: order_id_final, // Ensure this maps to primary_id in Django
            guest_id: 0,
            guest_name: "",
            guest_mobile_no: "",
            entry_date: new Date().toISOString(),
            guest_email: "",
            guest_address: "",
            pickup_date: null, // Ensure date format is correct before saving
            pickup_time: null, // Ensure time format is correct before saving
            reservation_id: 0,
            dining_area_id: extra_data.area_id,
            table_code_ids: extra_data.table_code_ids,
            table_area_name: extra_data.table_area_name,
            table_code_names: extra_data.table_no,
            order_type: order_type,
            table_no: extra_data.table_no,
            product_amount: 0,
            tax_per: 0,
            tax_amount: 0,
            packing_amount: 0,
            discount_id: 0,
            discount_code_name: "",
            discount_type: "",
            discount_custom_type: "",
            discount_reason: "",
            discount_amount: 0,
            delivery_amount: 0,
            assign_staff_id: 0,
            tip_amount: 0,
            roundoff_amount: 0,
            final_amount: 0,
            current_status: 0,
            special_instruction: "",
            remark_cancel: "",
            payment_mode: "Cash",
            payment_description: "",
            transaction_id: "",
            order_create: "offline", // If needed, add to Django model
            paid_or_not: 0, // Ensure integer type
            printed_table: 0, // Ensure integer type
            customer_paid_cash: "", // Ensure integer type
            printed_kot_table: 0, // Ensure integer type
            complimentary_table: 0, // Ensure integer type
            admin_id: retrievedAdminId, // Ensure integer type
            restaurant_id: retrievedRestaurantId, // Ensure integer type
            flag: "c",
          };

          let order_id_save = await store2.add(modifiedDataItem);
          const db = await initDB();
          const tx6 = db.transaction(CustomerOrder, "readwrite");
          const store6 = tx6.objectStore(CustomerOrder);
          const index6 = store6.index("order_id");
          let data_order_data = await new Promise((resolve, reject) => {
            const request = index6.getAll(order_id_final);
            request.onsuccess = () => {
              resolve(request.result);
            };
            request.onerror = (err) => {
              console.log(err);
              reject(err);
            };
            resolve(request);
          });
          if (order_id_save.result) {
            order_id_save = order_id_save.result;
          }
          // console.log(order_id_save);
          if (data_order_data.length > 0) {
            const lastData = { ...data_order_data[0] }; // Get the last entry

            // Remove unnecessary fields
            delete lastData.order_id;
            delete lastData.total_amount;

            // Update with new values
            const ExtraItem = {
              ...lastData,
              order_id: order_id_save,
              primary_id: order_id_save,
            };
            // console.log(ExtraItem);
            // Update the last record in IndexedDB
            await store6.put(ExtraItem);
            order_id_final = order_id_save;
          }
        }

        if (foundRecord !== null) {
          let plus_count = 0;
          if (extra_data.plus_min) {
            if (extra_data.plus_min === "plus") {
              plus_count = foundRecord.item_qty + 1;
            } else if (extra_data.plus_min === "remove") {
              plus_count = 0;
            } else {
              plus_count = foundRecord.item_qty - 1;
            }
          }

          let total_price = plus_count * item_original_price;
          if (plus_count > 0) {
            const { selectedAddons, ...restData } = foundRecord; // This removes 'id' from data
            const updatedDataItem = {
              ...restData,
              item_qty: plus_count,
              total_price_show_single:
                parseFloat(item_original_price).toFixed(2),
              selectedAddons: extra_data.selectedAddons,
              total_price_show: parseFloat(total_price).toFixed(2),
              variation_name: variation_name,
              data_type: "online",
            };
            store.put(updatedDataItem);
          } else if (plus_count === 0) {
            store.delete(foundRecord.id); // Remove item from store when quantity is 0
          }
          resolve(order_id_final);
        } else {
          const retrievedAdminId = retrieveData("admin_id");
          const retrievedRestaurantId = retrieveData("default_restaurant_id");
          const { id, entry_date, ...restData } = data; // This removes 'id' from data
          const modifiedDataItem = {
            ...restData,
            order_id: order_id_final,
            item_qty: 1,
            entry_date: new Date().toISOString(),
            table_no: extra_data.table_no,
            total_price_show_single: parseFloat(item_original_price).toFixed(2),
            total_price_show: parseFloat(item_original_price).toFixed(2),
            selectedAddons: extra_data.selectedAddons,
            selectedVariation: extra_data.selectedVariation,
            selectedcombo: extra_data.selectedcombo,
            variation_name: variation_name,
            item_id: data.primary_id,
            item_notes: "",
            data_type: "online",
            current_status: 0,
            admin_id: retrievedAdminId, // Ensure integer type
            restaurant_id: retrievedRestaurantId, // Ensure integer type
          };
          modifiedDataItem.item_original_price =
            parseFloat(item_original_price).toFixed(2);
          let order_detail_id = 0;
          const db = await initDB();
          order_detail_id = await db.add(CustomerOrderDetail, modifiedDataItem);
          // Update newCustomerEntry with the generated primary_id
          modifiedDataItem.primary_id = order_detail_id;
          modifiedDataItem.id = order_detail_id;
          // Update record with correct primary_id
          await db.put(CustomerOrderDetail, modifiedDataItem);
          resolve(order_id_final);
        }
      };
      request.onerror = () => reject("Error retrieving records");
    });
  } catch (error) {
    console.error(`StoreDataItemintoIndexDB Error:`, error);
    return [];
  }
};

// Helper: Parse selectedAddons string safely
function parseAddons(addons) {
  try {
    return typeof addons === "string" ? JSON.parse(addons) : addons || [];
  } catch (e) {
    return [];
  }
}

// Helper: Compare two addon arrays based on addon 'id'
function areAddonsEqual(addons1, addons2) {
  const parsed1 = Array.isArray(addons1) ? addons1 : parseAddons(addons1);
  const parsed2 = Array.isArray(addons2) ? addons2 : parseAddons(addons2);

  // Defensive: Ensure arrays
  const safe1 = Array.isArray(parsed1) ? parsed1 : [];
  const safe2 = Array.isArray(parsed2) ? parsed2 : [];

  if (safe1.length !== safe2.length) return false;

  const ids1 = safe1.map((a) => a.id).sort();
  const ids2 = safe2.map((a) => a.id).sort();

  return ids1.every((id, i) => id === ids2[i]);
}

const StoreDataPaymentintoIndexDB = async (db, extra_data = {}) => {
  if (!db) {
    db = await initDB();
  }
  const retrievedAdminId = retrieveData("admin_id");
  const retrievedRestaurantId = retrieveData("default_restaurant_id");
  const modifiedDataItem = {
    order_id: parseInt(extra_data.order_id),
    restaurant_id: retrievedRestaurantId,
    admin_id: retrievedAdminId,
    entry_date: new Date().toISOString(),
    payment_mode: extra_data.payment_mode,
    payment_amount: extra_data.payment_amount,
    guest_id: extra_data.guest_id,
    payment_comment: extra_data.payment_comment,
    data_type: "online",
    flag: "c",
  };

  try {
    let tx = db.transaction(CustomerOrderPaymentMode, "readwrite");
    let store = tx.objectStore(CustomerOrderPaymentMode);

    let payment_id_id = await store.add(modifiedDataItem);

    let payment_id = await new Promise((resolve, reject) => {
      payment_id_id.onsuccess = () => {
        resolve(payment_id_id.result);
      };
      payment_id_id.onerror = (err) => {
        console.log(err);
        reject(err);
      };
      // resolve(payment_id_id);
    });
    modifiedDataItem.primary_id = payment_id;
    modifiedDataItem.id = payment_id;

    await store.put(modifiedDataItem);
    await tx.done;
  } catch (error) {
    console.error("IndexedDB Error:", error);
  }
};

const UpdateDataGuestAmountintoIndexDB = async (db, extra_data) => {
  try {
    const tx6 = db.transaction(GuestInformation, "readwrite");
    const store6 = tx6.objectStore(GuestInformation);

    let result = await store6.get(extra_data.guest_id); // ID ke basis pe data fetch karega
    // console.log(result);
    let result_data = await new Promise((resolve, reject) => {
      result.onsuccess = () => {
        resolve(result.result);
      };
      result.onerror = (err) => {
        console.log(err);
        reject(err);
      };
      // resolve(payment_id_id);
    });
    result_data.amount_of_booking_due -= parseFloat(
      extra_data.amount_of_booking_due
    );
    await store6.put(result_data); // ID ke basis pe data fetch karega
  } catch (error) {
    console.error(`UpdateDataGuestAmountintoIndexDB Error:`, error);
    return [];
  }
};

const UpdateDataItemDetailsintoIndexDB = async (
  db,
  data_order_data,
  extra_data
) => {
  try {
    const tx6 = db.transaction(CustomerOrderDetail, "readwrite");
    const store6 = tx6.objectStore(CustomerOrderDetail);

    const lastData = { ...data_order_data }; // Get the last entry
    let item_notes = "";
    if (extra_data.special_notes) {
      item_notes = extra_data.special_notes;
      delete lastData.item_notes;

      // Update with new values
      const ExtraItem = {
        ...lastData,
        item_notes: item_notes,
      };
      await store6.put(ExtraItem);
    }
    // Remove unnecessary fields
  } catch (error) {
    console.error(`UpdateDataItemDetailsintoIndexDB Error:`, error);
    return [];
  }
};

const UpdateDataReservationIndexDB = async (
  db,
  data_order_data,
  extra_data
) => {
  try {
    const tx6 = db.transaction(ReservationInformation, "readwrite");
    const store6 = tx6.objectStore(ReservationInformation);

    const lastData = { ...data_order_data }; // Get the last entry
    if (extra_data.booking_status) {
      if (extra_data.booking_status === 4) {
        delete lastData.booking_status;
        delete lastData.notify_flag;
        delete lastData.update_date;
        delete lastData.no_show_time;
        delete lastData.table_code_ids;
        delete lastData.no_show_status;
        delete lastData.table_code_names;
        delete lastData.total_table_combine;
        delete lastData.dining_area_id;

        const now = new Date();
        // Update with new values
        const ExtraItem = {
          ...lastData,
          booking_status: extra_data.booking_status,
          notify_flag: 1,
          update_date: now.toISOString(), // full ISO datetime
          no_show_time: now.toTimeString().split(" ")[0], // gets "HH:MM:SS"
          table_code_ids: "",
          no_show_status: 0,
          table_code_names: "",
          total_table_combine: "0",
          dining_area_id: 0,
        };
        await store6.put(ExtraItem);
      } else if (extra_data.booking_status === 6) {
        delete lastData.booking_status;
        delete lastData.notify_flag;
        delete lastData.update_date;
        delete lastData.cancel_time;
        delete lastData.table_code_ids;
        delete lastData.table_code_names;
        delete lastData.total_table_combine;
        delete lastData.dining_area_id;
        const now = new Date();
        // Update with new values
        const ExtraItem = {
          ...lastData,
          booking_status: extra_data.booking_status,
          notify_flag: 1,
          update_date: now.toISOString(), // full ISO datetime
          cancel_time: now.toTimeString().split(" ")[0], // gets "HH:MM:SS"
          table_code_ids: "",
          table_code_names: "",
          total_table_combine: "0",
          dining_area_id: 0,
        };
        await store6.put(ExtraItem);
      } else if (extra_data.booking_status === 8) {
        delete lastData.booking_status;
        delete lastData.notify_flag;
        delete lastData.update_date;
        delete lastData.table_code_ids;
        delete lastData.table_code_names;
        delete lastData.total_table_combine;
        delete lastData.dining_area_id;
        const now = new Date();
        // Update with new values
        const ExtraItem = {
          ...lastData,
          booking_status: extra_data.booking_status,
          notify_flag: 1,
          update_date: now.toISOString(), // full ISO datetime
          table_code_ids: "",
          table_code_names: "",
          total_table_combine: "0",
          dining_area_id: 0,
        };
        await store6.put(ExtraItem);
      } else if (extra_data.booking_status === 1) {
        delete lastData.booking_status;
        delete lastData.notify_flag;
        delete lastData.update_date;
        delete lastData.no_show_status;
        delete lastData.table_code_ids;
        delete lastData.table_code_names;
        delete lastData.total_table_combine;
        delete lastData.dining_area_id;

        const now = new Date();
        // Update with new values
        const ExtraItem = {
          ...lastData,
          booking_status: extra_data.booking_status,
          notify_flag: 1,
          update_date: now.toISOString(), // full ISO datetime
          no_show_status: 1, // full ISO datetime
          table_code_ids: "",
          table_code_names: "",
          total_table_combine: "0",
          dining_area_id: 0,
        };
        await store6.put(ExtraItem);
      } else if (extra_data.booking_status === 3) {
        delete lastData.booking_status;
        delete lastData.notify_flag;
        delete lastData.payout_amt;
        delete lastData.invoice_no_bill;
        delete lastData.release_time;
        delete lastData.update_date;

        const now = new Date();
        // Update with new values
        const ExtraItem = {
          ...lastData,
          booking_status: extra_data.booking_status,
          notify_flag: 1,
          payout_amt: extra_data.payout_amt,
          invoice_no_bill: extra_data.invoice_no_bill,
          release_time: now.toTimeString().split(" ")[0], // gets "HH:MM:SS"
          update_date: now.toISOString(), // full ISO datetime
        };
        await store6.put(ExtraItem);
      } else if (
        extra_data.booking_status === 2 ||
        extra_data.booking_status === 7
      ) {
        delete lastData.booking_status;
        delete lastData.table_alloted;
        delete lastData.table_code_ids;
        delete lastData.table_code_names;
        delete lastData.notify_flag;
        delete lastData.total_table_combine;
        delete lastData.arrival_time;
        delete lastData.dining_area_id;

        const now = new Date();
        // Update with new values
        const ExtraItem = {
          ...lastData,
          booking_status: extra_data.booking_status,
          table_alloted: 1,
          table_code_ids: extra_data.table_code_ids,
          table_code_names: extra_data.table_code_names,
          notify_flag: 1,
          total_table_combine: "0",
          arrival_time: now.toTimeString().split(" ")[0], // gets "HH:MM:SS"
          dining_area_id: extra_data.dining_area_id,
        };
        await store6.put(ExtraItem);
      } else {
        delete lastData.booking_status;
        delete lastData.notify_flag;
        delete lastData.update_date;
        delete lastData.no_show_status;

        const now = new Date();
        // Update with new values
        const ExtraItem = {
          ...lastData,
          booking_status: extra_data.booking_status,
          notify_flag: 1,
          update_date: now.toISOString(), // full ISO datetime
          no_show_status: 0, // full ISO datetime
        };
        await store6.put(ExtraItem);
      }
    }

    await add_update_to_sync_table(lastData.primary_id, 7, {
      order_id: lastData.primary_id,
      book_date: lastData.book_date,
      book_time: lastData.book_time,
      guest_mobile_no: lastData.guest_mobile_no,
      customer_update: "Update",
    });
    // Remove unnecessary fields
  } catch (error) {
    console.error(`UpdateDataItemDetailsintoIndexDB Error:`, error);
    return [];
  }
};

const StoreDataCustomerOrderintoIndexDB = async (db, data, order_id) => {
  try {
    let store;
    if (db) {
      store = db
        .transaction(CustomerOrder, "readwrite")
        .objectStore(CustomerOrder);
    } else {
      store = await initDB().then((db) =>
        db.transaction(CustomerOrder, "readwrite").objectStore(CustomerOrder)
      );
    }
    const index = store.index("order_id");

    order_id = isNaN(order_id) ? String(order_id) : parseInt(order_id); // Ensure correct type

    const request = index.getAll(order_id);
    const records = await new Promise((resolve, reject) => {
      request.onsuccess = () => resolve(request.result);
      request.onerror = (err) => reject(err);
    });

    const foundRecord = records.find(
      (record) => record.order_id === order_id || record.primary_id === order_id
    );
    if (!foundRecord) return null;

    // Dynamically update only the provided fields
    Object.keys(data).forEach((key) => {
      foundRecord[key] =
        key === "entry_date" ? new Date().toISOString() : data[key];
    });

    const updateRequest = store.put(foundRecord);
    await new Promise((resolve, reject) => {
      updateRequest.onsuccess = () => resolve(foundRecord);
      updateRequest.onerror = (err) => reject(err);
    });

    return foundRecord;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

const StoreDataCustomerOrderDetailsintoIndexDB = async (db, data, order_id) => {
  try {
    let store;
    if (db) {
      store = db
        .transaction(CustomerOrderDetail, "readwrite")
        .objectStore(CustomerOrderDetail);
    } else {
      store = await initDB().then((db) =>
        db
          .transaction(CustomerOrderDetail, "readwrite")
          .objectStore(CustomerOrderDetail)
      );
    }
    const index = store.index("order_id");

    order_id = isNaN(order_id) ? String(order_id) : parseInt(order_id); // Ensure correct type

    const request = index.getAll(order_id);
    const records = await new Promise((resolve, reject) => {
      request.onsuccess = () => resolve(request.result);
      request.onerror = (err) => reject(err);
    });

    const foundRecord = records.find((record) => record.order_id === order_id);
    if (!foundRecord) return null;

    // Dynamically update only the provided fields
    Object.keys(data).forEach((key) => {
      foundRecord[key] =
        key === "entry_date" ? new Date().toISOString() : data[key];
    });

    const updateRequest = store.put(foundRecord);
    await new Promise((resolve, reject) => {
      updateRequest.onsuccess = () => resolve(foundRecord);
      updateRequest.onerror = (err) => reject(err);
    });

    return foundRecord;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

const getAllSyncData = async () => {
  const db = await initDB();
  return db.getAll(SYNC_STORE);
};

const clearSyncTableBeforeId = (idThreshold) => {
  return new Promise(async (resolve, reject) => {
    const db = await openIndexDB();
    const tx = db.transaction(SYNC_STORE, "readwrite");
    const store = tx.objectStore(SYNC_STORE);
    let deletedCount = 0;

    const range = IDBKeyRange.upperBound(idThreshold);
    const cursorRequest = store.openCursor(range);

    cursorRequest.onsuccess = (event) => {
      const cursor = event.target.result;

      if (cursor) {
        cursor.delete();
        deletedCount++;
        cursor.continue();
      }
    };

    cursorRequest.onerror = (event) => {
      reject(`Cursor error: ${event.target.error}`);
    };

    tx.oncomplete = () => {
      console.log(`Transaction completed. Deleted ${deletedCount} records.`);
      resolve(deletedCount);
    };

    tx.onerror = (event) => {
      reject(`Transaction error: ${event.target.error}`);
    };
  });
};

const CreateEmptyOrderForTable = async (
  db,
  extra_data = {},
  order_type = ""
) => {
  try {
    // console.log("asdasdsaasadass", extra_data);

    const transaction = db.transaction(CustomerOrder, "readwrite");
    const store = transaction.objectStore(CustomerOrder);
    const store1 = transaction.objectStore(CustomerOrder);
    let index = store.index("table_no");
    let keyRange = IDBKeyRange.only(extra_data.table_code_names);
    const existingOrderRequest = index.getAll(keyRange);

    return new Promise((resolve, reject) => {
      existingOrderRequest.onsuccess = async () => {
        const records = existingOrderRequest.result;
        // console.log(records);
        const activeOrderExists = records.some(
          (item) =>
            parseInt(item.current_status) !== 2 &&
            parseInt(item.current_status) !== 10
        );

        if (activeOrderExists) {
          const existingOrder = records.find(
            (item) =>
              parseInt(item.current_status) !== 2 &&
              parseInt(item.current_status) !== 10
          );
          resolve(existingOrder.order_id); // Return existing order_id
          return;
        }

        // Convert order_type to backend-required format
        let orderTypeCode = "0";
        if (order_type === "dine") orderTypeCode = "3";
        else if (order_type === "delivery") orderTypeCode = "2";
        else if (order_type === "take") orderTypeCode = "1";
        const retrievedAdminId = retrieveData("admin_id");
        const retrievedRestaurantId = retrieveData("default_restaurant_id");
        const newOrderData = {
          order_id: 0,
          primary_id: 0,
          guest_id: 0,
          guest_name: "",
          guest_mobile_no: "",
          entry_date: new Date().toISOString(),
          guest_email: "",
          guest_address: "",
          pickup_date: null,
          pickup_time: null,
          reservation_id: extra_data.reservation_id,
          dining_area_id: extra_data.area_id,
          table_code_ids: extra_data.table_code_ids,
          table_area_name: extra_data.table_area_name,
          table_code_names: extra_data.table_code_names,
          order_type: orderTypeCode,
          table_no: extra_data.table_code_names,
          book_date: extra_data.book_date,
          book_time: extra_data.book_time,
          guest_mobile_no_rese: extra_data.guest_mobile_no,
          product_amount: 0,
          tax_per: 0,
          tax_amount: 0,
          packing_amount: 0,
          discount_id: 0,
          discount_code_name: "",
          discount_type: "",
          discount_custom_type: "",
          discount_reason: "",
          discount_amount: 0,
          delivery_amount: 0,
          assign_staff_id: 0,
          tip_amount: 0,
          roundoff_amount: 0,
          final_amount: 0,
          current_status: 0,
          special_instruction: "",
          remark_cancel: "",
          payment_mode: "Cash",
          payment_description: "",
          transaction_id: "",
          order_create: "offline",
          paid_or_not: 0,
          printed_table: 0,
          customer_paid_cash: "",
          printed_kot_table: 0,
          complimentary_table: 0,
          admin_id: retrievedAdminId,
          restaurant_id: retrievedRestaurantId,
          flag: "c",
        };

        const order_id_save = await new Promise((resolve, reject) => {
          const addRequest = store.add(newOrderData);
          addRequest.onsuccess = () => {
            resolve(addRequest.result);
          };
          addRequest.onerror = () => {
            console.error("Failed to save new order");
            reject("Error saving new order");
          };
        });

        // console.log("sdnjsndj", order_id_save);

        const latestData = { ...newOrderData };
        delete latestData.order_id;
        delete latestData.primary_id;

        const finalOrder = {
          ...latestData,
          order_id: order_id_save,
          primary_id: order_id_save,
          id: order_id_save,
        };

        await store1.put(finalOrder);

        await add_update_to_sync_table(order_id_save, 1, {
          kot_primary_id: 0,
          order_id: order_id_save,
        });

        // ✅ Update ReservationInformation with table_code_ids
        // const reservationTx = dbNew.transaction(ReservationInformation, "readwrite");
        // const reservationStore = reservationTx.objectStore(ReservationInformation);
        const transaction2 = db.transaction(
          ReservationInformation,
          "readwrite"
        );
        const store2 = transaction2.objectStore(ReservationInformation);
        const getReservationRequest = store2.get(extra_data.reservation_id);

        getReservationRequest.onsuccess = async () => {
          const reservationData = getReservationRequest.result;

          if (reservationData) {
            await UpdateDataReservationIndexDB(db, reservationData, {
              booking_status: 2,
              table_code_ids: extra_data.table_code_ids,
              table_code_names: extra_data.table_code_names,
              total_table_combine: "0",
              dining_area_id: extra_data.area_id,
            });
          } else {
            console.warn(
              "Reservation not found with ID",
              extra_data.reservation_id
            );
          }
        };

        getReservationRequest.onerror = (err) => {
          console.error("Failed to fetch reservation data", err);
        };

        resolve(order_id_save); // Finally resolve with order ID
      };

      existingOrderRequest.onerror = () => {
        reject("Failed to check existing table order");
      };
    });
  } catch (err) {
    console.error("CreateEmptyOrderForTable Error:", err);
    return null;
  }
};

export {
  deleteDatabase,
  StoreDataintoIndexDB,
  StoreDataPaymentintoIndexDB,
  RetrieveDataintoIndexDB,
  RetrieveDataintoIndexDBOrder,
  StoreDataItemintoIndexDB,
  StoreDataCustomerOrderintoIndexDB,
  StoreDataCustomerOrderDetailsintoIndexDB,
  UpdateDataItemDetailsintoIndexDB,
  UpdateDataReservationIndexDB,
  UpdateDataGuestAmountintoIndexDB,
  clearSyncTableBeforeId,
  CreateEmptyOrderForTable,
};
